module.exports = __webpack_public_path__ + "img/shot_bigtx121301.39e029ac.png";